import { AgentReferenceType } from '@/agent/references/store/schemas'
import { fetchAgentCaselawHtml } from '@/agent/references/fetch/fetchAgentCaselawHtml'
import { fetchAgentLrrHtml } from '@/agent/references/fetch/fetchAgentLrrHtml'

export async function getAgentReferenceHtml(type: AgentReferenceType, s3_path: string): Promise<{ data: string } | null> {
  if (!s3_path) {
    throw new Error('No s3_path found in reference metadata')
  }

  // Fetch HTML based on reference type
  let result
  if (type === AgentReferenceType.CASELAW) {
    result = await fetchAgentCaselawHtml(s3_path)
  } else {
    result = await fetchAgentLrrHtml(s3_path)
  }

  return result
}
